import { AIProject, CellField, LinkedRecord } from "./types";

export const makeAIProjects = (projectData: any, expectedBenefitsData: any[], endCustomersData: any[], businessValueData: any[]): AIProject[] => {

    const projects = projectData.map((item: any) => {

        const businessUnit = getFirstValue(item.fields[CellField.BU]) ?? ""

        const expectedBenefitsRecordId = item.fields[CellField.ExpectedBenefits]?.[0]
        const expectedBenefitDataItem = expectedBenefitsRecordId ? expectedBenefitsData.find(item => item.id === expectedBenefitsRecordId) : undefined
        const expectedBenefits = expectedBenefitDataItem ? expectedBenefitDataItem.fields["Amount"] : ""

        const endCustomersRecordIds = item.fields[CellField.EndCustomers]
        const endCustomers = endCustomersRecordIds
            .map((id: any) => {
                const endCustomersDataItem = endCustomersData?.find(item => item.id === id) // Safe navigation
                return endCustomersDataItem ? endCustomersDataItem.fields["Option"] : null
            })
            .filter((item: null) => item !== null) // Filter out null values to avoid sorting them
            .sort()

        const businessValueRecordIds = item.fields[CellField.BusinessValue]
        console.log("🚀 ~ projects ~ businessValueRecordIds:", businessValueRecordIds)
        const businessValue = businessValueRecordIds
            .map((id: any) => {
                const businessValueDataItem = businessValueData?.find(item => item.id === id) // Safe navigation
                console.log("🚀 ~ .map ~ businessValueDataItem:", businessValueDataItem)
                return businessValueDataItem ? businessValueDataItem.fields["Option"] : null
            })
            .filter((item: null) => item !== null) // Filter out null values to avoid sorting them
            .sort()
        console.log("🚀 ~ projects ~ businessValue:", businessValue)



        const project: AIProject = {
            id: item.id,
            name: item.fields[CellField.Project],
            summary: item.fields[CellField.Summary] ?? "",
            jiraId: item.fields[CellField.JiraID] ?? "",
            status: item.fields[CellField.Status],
            businessUnit,
            stakeholders: item.fields[CellField.Stakeholders] ?? "",
            endCustomers: endCustomers,
            solution: item.fields[CellField.SolutionCallToAction] ?? "",
            buisinessValue: businessValue,
            budget: "",
            expectedBenefits: expectedBenefits,
            dataInputs: item.fields[CellField.DataInputs] ?? "",
            output: item.fields[CellField.OutputIntegration] ?? "",
            successCriteria: item.fields[CellField.SuccessCriteria] ?? "",
            problemStatement: item.fields[CellField.ProblemStatement] ?? "",
            jiraURL: item.fields["Jira Link"]?.url ?? "",
            confluenceURL: item.fields["Confluence Link"]?.url,
            requestorName: item.fields[CellField.RequestorName] ?? "",
            stakeholderNames: item.fields["Stakeholder Names"] ?? [],
            notes: item.fields[CellField.Notes] ?? "",
            rationale: item.fields[CellField.Rationale] ?? "",
            teamsURL: item.fields["Teams Chat URL"] ?? "",
        }


        return project
    })

    return projects
}

function getFirstValue(array: any[] | undefined): any | undefined {
    if (array === undefined) {
        return undefined
    }
    if (array.length >= 1) {
        return array[0]
    } else {
        return undefined
    }
}
